module.exports = __webpack_public_path__ + "media/assets/kipp-2490774cafdbed7c8dcda799fc8b870b.png";